import * as Types from '../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { DimensionFragmentDoc } from './load-dimensions.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateDimensionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  attributes: Types.DimensionInput;
}>;


export type UpdateDimensionMutation = { __typename?: 'Mutation', updateDimension?: { __typename?: 'UpdateDimensionPayload', successful: boolean, dimension?: { __typename?: 'Dimension', id: string, name: string, nameDe?: string | null, nameEn?: string | null, nameFr?: string | null, nameIt?: string | null, position: number, categories: Array<{ __typename?: 'Category', id: string, name: string, nameDe?: string | null, nameEn?: string | null, nameFr?: string | null, nameIt?: string | null, position: number, customIdentifier?: string | null, dimension: { __typename?: 'Dimension', id: string } }> } | null } | null };

export const UpdateDimensionDocument = gql`
    mutation UpdateDimension($id: ID!, $attributes: DimensionInput!) {
  updateDimension(id: $id, attributes: $attributes) {
    dimension {
      ...Dimension
    }
    successful
  }
}
    ${DimensionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDimensionGQL extends Apollo.Mutation<UpdateDimensionMutation, UpdateDimensionMutationVariables> {
    document = UpdateDimensionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }